import { Form, FormProps, InputProps } from 'semantic-ui-react';
import styled from 'styled-components';

import { useScrollToError } from 'pkg/useScrollToError';

import { breakpoint } from './theme';

const StyledForm = styled(Form)`
  &&& {
    font-size: 1.6rem;
  }
`;

const StyledInput = styled(Form.Input)`
  &&& {
    input {
      height: 4.4rem;
      color: ${({ theme }) => theme.palette.black.primary};
      border-color: ${({ theme }) => theme.palette.gray.gallery};
      border-radius: 5px;
      padding: 1rem 1.8rem;
      ${breakpoint.up.md`
        height: 5.6rem;
      `}
    }
    input:focus {
      border-color: ${({ theme }) => theme.palette.secondary};
    }
    input::placeholder {
      color: ${({ theme }) => theme.palette.black.black06};
    }

    label {
      font-weight: 600;
      font-size: 1.8rem;
    }
  }
`;

const FormInput = ({ label, placeholder, error, ...props }: InputProps) => (
  <StyledInput
    {...props}
    label={label}
    placeholder={placeholder}
    error={error}
    aria-invalid={Boolean(error)}
    aria-label={typeof label === 'string' ? label : placeholder}
  />
);

const FormButton = styled(Form.Button)`
  &&& {
    button {
      height: 4.4rem;
      font-size: 1.6rem;
      border-radius: 5px;
      font-weight: 600;

      ${breakpoint.up.md`
        height: 5.6rem;
        font-size: 2.2rem;
      `}
    }
  }
`;

const FormField = Form.Field;

const FormWithErrorHandling = (props: FormProps): JSX.Element => {
  useScrollToError();

  return <StyledForm {...props} />;
};

export { FormWithErrorHandling as Form, FormButton, FormField, FormInput };
